import Highcharts from 'highcharts';

export const figure38 = { 
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        marginLeft: 180,
        height: 800,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },

      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          stacking: 'normal',
        }
      },
  
      exporting: {
        enabled: false
      },
  
  
      xAxis: [{
        categories: [
          "Pacífico centro oriental",
"Pacífico sudoccidental",
"Pacífico nororiental",
"Atlántico nororiental",
"Pacífico centro-occidental",
"Océano Índico oriental",
"Océano Índico occidental",
"Atlántico sudoriental",
"Pacífico noroccidental",
"Atlántico centro occidental",
"Atlántico centro-oriental",
"Atlántico noroccidental",
"Atlántico sudoccidental",
"Pacífico sudoriental",
"Mediterráneo y Mar Negro",
         ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px',
          }
        },
      }],
      yAxis: [{ // Primary yAxis
        labels: {
          //format: '{value}%',
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 100,
        min: 0,
        tickInterval: 20,
        format: '{value.percentage}%',
        gridLineWidth: 0,
        floor: 0,
        title: {
          text: "%",
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        //headerFormat: '<div>{point.key}</div>',
        valueSuffix: '%',
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [
        {
            name: 'Insostenible',
            color: '#ed7d31',
            data: [ 13.33333333, 15.38461538, 16.12903226, 20.68965517, 22.44897959, 31.37254902, 31.70731707, 32.35294118, 34.61538462, 38.59649123, 42.85714286, 43.75, 53.33333333, 54.54545455, 62.5 ]
        },
        {
            name: 'Sostenible',
            color: '#5b9bd5',
            data: [ 86.66666667, 84.61538462, 83.87096774, 79.31034483, 77.55102041, 68.62745098, 68.29268293, 67.64705882, 65.38461538, 61.40350877, 57.14285714, 56.25, 46.66666667, 45.45454545, 37.5 ]
        },
      ]
};
